/**
 * Utility function to format price based on value ranges
 * - If price < 10: show 6 decimal points
 * - If price < 100: show 3 decimal points
 * - If price >= 100: show 2 decimal points
 */
export function formatPrice(price: number): string {
  if (price < 10) {
    return price.toFixed(6)
  } else if (price < 100) {
    return price.toFixed(3)
  } else {
    return price.toFixed(2)
  }
}

/**
 * Get the number of decimal places based on price value
 */
export function getPrecision(price: number): number {
  if (price < 10) {
    return 6
  } else if (price < 100) {
    return 3
  } else {
    return 2
  }
}

/**
 * Format large numbers with K, M, B suffixes for better readability
 * Examples:
 * - 1,234 → 1.23K
 * - 1,234,567 → 1.23M
 * - 1,234,567,890 → 1.23B
 * - 123 → 123 (no suffix for smaller numbers)
 */
export function formatLargeNumber(num: number): string {
  const absNum = Math.abs(num)
  const sign = num < 0 ? '-' : ''
  
  if (absNum >= 1_000_000_000) {
    // Billions
    return `${sign}${(absNum / 1_000_000_000).toFixed(2)}B`
  } else if (absNum >= 1_000_000) {
    // Millions
    return `${sign}${(absNum / 1_000_000).toFixed(2)}M`
  } else if (absNum >= 1_000) {
    // Thousands
    return `${sign}${(absNum / 1_000).toFixed(2)}K`
  } else {
    // Less than 1000, show as is with appropriate decimal places
    if (absNum >= 100) {
      return `${sign}${absNum.toFixed(0)}`
    } else if (absNum >= 10) {
      return `${sign}${absNum.toFixed(1)}`
    } else {
      return `${sign}${absNum.toFixed(2)}`
    }
  }
}